import GLightbox from "glightbox";

document.addEventListener("DOMContentLoaded", () => {
    // Initialize GLightbox for map buttons with data-map-embed (manual override)
    document.querySelectorAll('.wp-block-button__link[data-map-embed]').forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();

            const embedUrl = button.dataset.mapEmbed;
            const title = button.dataset.mapTitle || 'Map';

            const mapLightbox = GLightbox({
                elements: [{
                    type: 'inline',
                    content: `
                        <div class="map-popup-wrapper">
                            ${title ? `<h3 class="map-popup-title">${title}</h3>` : ''}
                            <div class="map-popup-content">
                                <iframe
                                    src="${embedUrl}"
                                    width="100%"
                                    height="100%"
                                    style="border:0; border-radius: 8px;"
                                    allowfullscreen=""
                                    loading="lazy"
                                    referrerpolicy="no-referrer-when-downgrade">
                                </iframe>
                            </div>
                        </div>
                    `
                }],
                width: '90vw',
                height: '80vh',
                closeButton: true,
                touchNavigation: false,
                loop: false,
                openEffect: 'fade',
                closeEffect: 'fade',
                draggable: false,
                zoomable: false
            });

            mapLightbox.open();
        });
    });

    // Auto-detect buttons with map-popup-enabled class or data-map-popup attribute
    const mapButtons = document.querySelectorAll('.wp-block-button[data-map-popup="true"] .wp-block-button__link, .wp-block-button.map-popup-enabled .wp-block-button__link');

    mapButtons.forEach(button => {
        // Skip if already has data-map-embed (manual override)
        if (button.dataset.mapEmbed) return;

        button.addEventListener('click', async (e) => {
            e.preventDefault();

            const originalUrl = button.href;
            let embedUrl = await convertToEmbedUrl(originalUrl);

            if (!embedUrl) {
                // Fallback: open in new tab if conversion fails
                window.open(originalUrl, '_blank');
                return;
            }

            const mapLightbox = GLightbox({
                elements: [{
                    type: 'inline',
                    content: `
                        <div class="map-popup-wrapper">
                            <div class="map-popup-content">
                                <iframe
                                    src="${embedUrl}"
                                    width="100%"
                                    height="100%"
                                    style="border:0; border-radius: 8px;"
                                    allowfullscreen=""
                                    loading="lazy"
                                    referrerpolicy="no-referrer-when-downgrade">
                                </iframe>
                            </div>
                        </div>
                    `
                }],
                width: '90vw',
                height: '80vh',
                closeButton: true,
                touchNavigation: false,
                loop: false,
                openEffect: 'fade',
                closeEffect: 'fade',
                draggable: false,
                zoomable: false
            });

            mapLightbox.open();
        });
    });


});

async function convertToEmbedUrl(originalUrl) {
    try {
        const url = new URL(originalUrl);

        // Handle shortened URLs (goo.gl, maps.app.goo.gl) - expand them first
        if (url.hostname.includes('goo.gl')) {
            const expandedUrl = await expandShortenedUrl(originalUrl);
            if (expandedUrl && expandedUrl !== originalUrl) {
                return convertToEmbedUrl(expandedUrl);
            } else {
                console.warn('Could not expand shortened URL, opening in new tab:', originalUrl);
                return null;
            }
        }

        if (url.hostname.includes('consent.google.com')) {
            const continueParam = url.searchParams.get('continue');
            if (continueParam) {
                const decodedUrl = decodeURIComponent(continueParam);
                return convertToEmbedUrl(decodedUrl);
            }
        }

        if (url.hostname.includes('maps.google.com') || url.hostname.includes('www.google.com')) {
            const coordMatch = originalUrl.match(/@(-?\d+\.?\d*),(-?\d+\.?\d*)/);
            if (coordMatch) {
                const [, lat, lng] = coordMatch;
                return `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3000!2d${lng}!3d${lat}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zM!5e0!3m2!1sen!2s!4v1234567890123!5m2!1sen!2s`;
            }

            const dataMatch = originalUrl.match(/\/data=([^&?#]+)/);
            if (dataMatch) {
                const dataParam = dataMatch[1];
                return `https://www.google.com/maps/embed?pb=${dataParam}`;
            }

            const searchParams = url.searchParams;
            const query = searchParams.get('q') || searchParams.get('query');
            if (query) {
                return `https://www.google.com/maps/embed/v1/place?key=YOUR_API_KEY&q=${encodeURIComponent(query)}`;
            }

            const placeMatch = originalUrl.match(/\/place\/([^\/]+)/);
            if (placeMatch) {
                const placeName = decodeURIComponent(placeMatch[1].replace(/\+/g, ' '));
                return `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3000!2d0!3d0!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zM!5e0!3m2!1sen!2s!4v1234567890123!5m2!1sen!2s&q=${encodeURIComponent(placeName)}`;
            }

            if (url.pathname.includes('/maps')) {
                return originalUrl.replace('maps.google.com', 'www.google.com/maps/embed');
            }
        }

        return null;
    } catch (error) {
        console.warn('Failed to convert map URL:', originalUrl, error);
        return null;
    }
}

async function expandShortenedUrl(shortUrl) {
    try {
        // You would need to create a server-side endpoint that expands URLs
        const response = await fetch(fintua.ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'expand_map_url',
                url: shortUrl,
                nonce: fintua.expand_map_url_nonce // You'd need to localize this
            })
        });

        const data = await response.json();
        return data.success ? data.data.expanded_url : null;
    } catch (error) {
        console.warn('Failed to expand URL:', error);
        return null;
    }
}
